import { determineBrand } from "@util/theme.js";

export const isEveryday = determineBrand() === "everyday";
export const isProfessional = determineBrand() === "professional";
export const isAnathoth = determineBrand() === "anathoth";
export const isBarkers = ["barkers-nz", "barkers-aus"].includes(
  determineBrand()
);
export const BUTTON_HEIGHT = 46;
export const HEADER_HEIGHT = 114;

// screen sizes
export const SMALLER_MOBILE = 360;
export const MOBILE_BREAKPOINT = 600;
export const IPAD_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1000;
export const IPAD_PRO_BREAKPOINT = 1025;
export const SMALL_LAPTOP_BREAKPOINT = 1280;
export const LAPTOP_BREAKPOINT = 1441;
export const TWENTY_INCH_SCREEN = 1600;
export const IMAC_BREAKPOINT = 1921;
export const DEFAULT_OFFSET = 120;
export const MOBILE_OFFSET = 60;

export const colors = {
  transparent: "transparent",
  white: "#fff",
  black: "#383637",
  merlin: "#3D3935",
  errorRed: "red",
  barkersDarkGray: "#252321",
  barkersLightGray: "#32302D",
  imageBackground: "#F6F4F4",
  lightGrayBackground: "#D3D3D3",
  beige: "#f3f1f2",
  // yellow: "#fff15e",
  yellow: "#FADB8B",
};

export const fontWeights = {
  normal: 300,
  bold: 600,
  mid: 400,
};

export const DEFAULT_FONT = "var(--theme-font)";
export const HEADER_FONT = "var(--theme-font-header)";
export const HEADER_SUB_FONT = "var(--theme-font-sub-header)";

export const fontSizes = isEveryday
  ? {
      p: { default: 16, alternate: 15, mobile: 16 },
      h1: { default: 50, mobile: 40 },
      h2: { default: 40, mobile: 25 },
      h3: { default: 30, mobile: 20 },
      h4: { default: 22, mobile: 18 },
      button: { default: 15, mobile: 12 },
    }
  : {
      p: {
        default: isAnathoth ? 17 : 16,
        alternate: isAnathoth ? 17 : 15,
        mobile: 16,
      },
      h1: { default: 50, mobile: 47 },
      h2: { default: 30, mobile: 25 },
      h3: { default: 38, mobile: 26 },
      h4: { default: 19, mobile: 15 },
      button: { default: 15, mobile: 12 },
    };

export const colorsRGB = {
  black: (opacity?: number) => `rgba(0, 0, 0, ${opacity ?? "0.2"})`,
  white: (opacity?: number) => `rgba(255, 255, 255, ${opacity ?? "0.3"})`,
  accordianBorder: (opacity?: number) => `rgba(61,57,53, ${opacity ?? "0.4"})`,
  merlin: (opacity?: number) => `rgba(61,57,53, ${opacity ?? "0.1"})`,
  barkersDarkGray: (opacity?: number) => `rgba(37,35,33, ${opacity ?? "0.1"})`,
  beige: (opacity?: number) => `rgba(243,241,242, ${opacity ?? "0.1"})`,
  green: (opacity?: number) => `rgba(56, 88, 75, ${opacity ?? "0.1"})`,
};

export const gradient = {
  featuredRecipeOverlay: `linear-gradient(90deg, ${colorsRGB.black(
    0.37
  )} 25.28%, ${colorsRGB.black(0)} 105.83%)`,
};

export const pages = {
  home: "/",
  aboutUs: "/about-us",
  contactUs: "/contact-us",
  search: "/search",
  notFound: "/404",
};

export const slug = {
  gifting: "gifting",
  shopAll: "shop-all",
  recipes: "recipes",
  blog: "blogs",
};

// define paths to asset
export const assets = {
  logo: require("@static/assets/logo.png").default,
  textureBg: require("@static/assets/texture-bg.jpg").default,
  arrowDown: require("@static/assets/arrow-down.svg").default,
  arrowUp: require("@static/assets/arrow-up.svg").default,
  arrowDownDark: require("@static/assets/arrow-down-dark.svg").default,
  arrowUpDark: require("@static/assets/arrow-up-dark.svg").default,
  search: require("@static/assets/search.svg").default,
  searchDark: require("@static/assets/search-dark.svg").default,
  cartDark: require("@static/assets/cart-dark.svg").default,
  cart: require("@static/assets/cart.svg").default,
  account: require("@static/assets/account.svg").default,
  accountDark: require("@static/assets/account-dark.svg").default,
  hamburger: require("@static/assets/hamburger.svg").default,
  hamburgerDark: require("@static/assets/hamburger-dark.svg").default,
  arrowRight: require("@static/assets/right-arrow.svg").default,
  favouriteIcon: require("@static/assets/favourite.svg").default,
  favouritedIcon: require("@static/assets/favourited.svg").default,
  arrowLeft: require("@static/assets/arrow-left.svg").default,
  arrowLeftWhite: require("@static/assets/arrow-left-white.svg").default,
  arrowRightWhite: require("@static/assets/arrow-right-white.svg").default,
  tags: require("@static/assets/tags.svg").default,
  instaBlack: require("@static/assets/insta_black.svg").default,
  facebookBlack: require("@static/assets/fb_black.svg").default,
  pinBlack: require("@static/assets/pin_black.svg").default,
  methodBackground: require("@static/assets/methodBackground.jpg").default,
  close: require("@static/assets/close.svg").default,
  stockists: require("@static/assets/stockists.jpg").default,
  delivery: require("@static/assets/delivery.jpg").default,
  accountHero: require("@static/assets/accountHero.jpg").default,
  accountHero2: require("@static/assets/account.jpg").default,
  placeholder: require("@static/assets/placeholder.svg").default,
  copyIcon: require("@static/assets/copy.svg").default,
  arrowEnter: require("@static/assets/arrow-enter.svg").default,
  bundleEmpty: require("@static/assets/bundle-empty.svg").default,
  bundleFull: require("@static/assets/bundle-full.svg").default,
};

export const vimeoUrls = {
  background: (url: string) =>
    `https://player.vimeo.com/video/${url}?api=1&background=1&autoplay=1&loop=1&byline=0&title=0&muted=1`,
  standard: (url: string) =>
    `https://player.vimeo.com/video/${url}?api=1&autoplay=1&controls=1`,
};
